import type { CustomResult } from '@creanizer/types'

interface CustomViewerProps {
  document: CustomResult
}

export function CustomViewer({ document }: CustomViewerProps) {
  // データ検証
  if (!document || !document.content) {
    return (
      <div className="p-6 bg-gray-50 rounded-lg">
        <h3 className="text-lg font-semibold mb-4">カスタム文献</h3>
        <pre className="text-sm text-gray-700 whitespace-pre-wrap">
          {JSON.stringify(document, null, 2)}
        </pre>
      </div>
    )
  }
  
  return (
    <div className="max-w-4xl mx-auto p-8 bg-white shadow-sm rounded-lg">
      {document.title && (
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          {document.title}
        </h1>
      )}
      
      {document.format && (
        <div className="text-sm text-gray-600 mb-4 italic">
          形式: {document.format}
        </div>
      )}
      
      {/* 本文（content）を表示 */}
      {document.content && (
        <div className="text-gray-700 whitespace-pre-wrap leading-relaxed mb-6">
          {document.content}
        </div>
      )}

      {/* セクションがあれば追加で表示 */}
      {document.sections && document.sections.length > 0 && (
        <div className="space-y-6">
          {document.sections.map((section, index) => (
            <div key={index}>
              {section.heading && (
                <h2 className="text-lg font-semibold text-gray-800 mb-2">
                  {section.heading}
                </h2>
              )}
              <div className="text-gray-700 whitespace-pre-wrap leading-relaxed">
                {section.content}
              </div>
            </div>
          ))}
        </div>
      )}
      
      {document.metadata?.customType && (
        <div className="mt-6 pt-4 border-t border-gray-200 text-sm text-gray-500">
          タイプ: {document.metadata.customType}
        </div>
      )}
    </div>
  )
}